<div class="ne-wrap">

  <div class="ne-header">
    <button class="ne-back-btn" (click)="cancel()">
      <mat-icon>arrow_back</mat-icon> Volver
    </button>
    <h2 class="ne-header__title">{{ isEditing ? 'Editar campaña' : 'Nueva campaña' }}</h2>
  </div>

  <div *ngIf="loading" class="ne-state">
    <div class="ne-spinner"></div><span>Cargando...</span>
  </div>
  <div *ngIf="errorMessage" class="ne-error">{{ errorMessage }}</div>

  <div class="ne-grid" *ngIf="!loading">

    <!-- ── Formulario ─────────────────────────────────────────── -->
    <div class="ne-panel">

      <h3 class="ne-section">Información básica</h3>

      <div class="ne-field">
        <label class="ne-label">Nombre de la campaña *</label>
        <input class="ne-input" type="text" [(ngModel)]="name" placeholder="Ej: Newsletter Enero 2026" />
      </div>
      <div class="ne-field">
        <label class="ne-label">Asunto del correo *</label>
        <input class="ne-input" type="text" [(ngModel)]="subject" placeholder="Asunto que verá el destinatario" />
      </div>
      <div class="ne-field">
        <label class="ne-label">Partir desde plantilla</label>
        <select class="ne-select" [(ngModel)]="templateId" (change)="onTemplateChange()">
          <option [ngValue]="null">-- Ninguna (escribir desde cero) --</option>
          <option *ngFor="let t of templates" [ngValue]="t.id">{{ t.name }}</option>
        </select>
      </div>

      <h3 class="ne-section">Contenido</h3>
      <p class="ne-hint">Variables disponibles: <code>{{ '{nombre}' }}</code>, <code>{{ '{email}' }}</code></p>

      <quill-editor
        [(ngModel)]="htmlContent"
        (onContentChanged)="onHtmlChange()"
        [modules]="quillModules"
        placeholder="Escribe aquí el contenido del correo..."
        [styles]="{ height: '350px' }">
      </quill-editor>

      <h3 class="ne-section">Destinatarios</h3>

      <div class="ne-field">
        <label class="ne-label">Segmento *</label>
        <select class="ne-select" [(ngModel)]="segmentType" (change)="audiencePreview = null">
          <option value="ALL">Todos los usuarios</option>
          <option value="BY_ROLE">Por rol</option>
          <option value="MANUAL_LIST">Lista manual</option>
        </select>
      </div>

      <div class="ne-field" *ngIf="segmentType === 'BY_ROLE'">
        <label class="ne-label">Rol</label>
        <select class="ne-select" [(ngModel)]="segmentValue">
          <option value="">-- Selecciona un rol --</option>
          <option *ngFor="let ut of userTypes" [value]="ut.id">{{ ut.name }}</option>
        </select>
      </div>

      <div class="ne-field" *ngIf="segmentType === 'MANUAL_LIST'">
        <label class="ne-label">Emails (separados por coma, espacio o salto de línea)</label>
        <textarea class="ne-textarea" [(ngModel)]="segmentValue" rows="4"
                  placeholder="ejemplo1@correo.com, ejemplo2@correo.com"></textarea>
      </div>

      <div class="ne-audience-row">
        <button mat-stroked-button color="primary" (click)="previewAudience()">
          <mat-icon>group</mat-icon> Ver destinatarios
        </button>
        <div *ngIf="audiencePreview" class="ne-audience-info">
          <strong>{{ audiencePreview.totalCount }}</strong> destinatarios
          <span *ngIf="audiencePreview.sampleEmails?.length > 0" class="ne-audience-info__sample">
            (ej: {{ audiencePreview.sampleEmails.slice(0, 3).join(', ') }}{{ audiencePreview.sampleEmails.length > 3 ? '...' : '' }})
          </span>
        </div>
      </div>

      <h3 class="ne-section">Envío de prueba</h3>
      <div class="ne-row">
        <input class="ne-input" type="email" [(ngModel)]="testEmail" placeholder="tu-email@correo.com" />
        <button mat-stroked-button color="accent" (click)="sendTest()" [disabled]="sendingTest">
          <mat-icon>send</mat-icon> {{ sendingTest ? 'Enviando...' : 'Enviar prueba' }}
        </button>
      </div>

      <h3 class="ne-section">Programar envío <span class="ne-section__opt">(opcional)</span></h3>
      <div class="ne-row">
        <input class="ne-input ne-datetime" type="datetime-local" [(ngModel)]="scheduledAt" />
        <button mat-stroked-button color="primary" (click)="schedule()">
          <mat-icon>schedule</mat-icon> Programar
        </button>
      </div>

      <div class="ne-action-bar">
        <button mat-stroked-button (click)="cancel()">Cancelar</button>
        <button mat-stroked-button color="primary" (click)="save()" [disabled]="saving">
          {{ saving ? 'Guardando...' : 'Guardar borrador' }}
        </button>
        <button mat-flat-button color="warn" (click)="sendNow()">
          <mat-icon>send</mat-icon> Enviar ahora
        </button>
      </div>

    </div>

    <!-- ── Vista previa ───────────────────────────────────────── -->
    <div class="ne-panel ne-panel--preview">
      <h3 class="ne-panel__preview-title">Vista previa</h3>
      <p class="ne-hint">Así se verá el correo con datos de ejemplo.</p>
      <div class="ne-preview-frame" [innerHTML]="previewHtml"></div>
    </div>

  </div>
</div>
